import {
  PendingContractAction,
  PendingContractActionTypes,
  PendingContractState,
} from "./types";

const initialState: PendingContractState = {
  id: "",
  purchaseDate: null,
  customerAddress: "",
  storeName: "",
  salesPerson: "",
  invoiceImg: "",
  invoiceNumber: "",
  contractPurchaseDate: null,
  customerFirstName: "",
  customerLastName: "",
  recordType: "",
  sellingStoreLocation: "",
  sellingStoreAddress: "",
  sellingStoreCity: "",
  sellingStoreState: "",
  sellingStorePostalCode: "",
  sellingStoreCountryCode: "",
  salesPersonId: "",
  customerId: "",
  customerStreetAddress1: "",
  customerStreetAddress2: "",
  customerCity: "",
  customerState: "",
  customerPostalCode: "",
  customerCountryCode: "",
  customerEmail: "",
  customerPrimaryTelephone: "",
  customerAlternativeTelephone: "",
  customerDeliveryStreetAddress1: "",
  customerDeliveryStreetAddress2: "",
  customerDeliveryCity: "",
  customerDeliveryState: "",
  customerDeliveryPostalCode: "",
  customerDeliveryCountryCode: "",
  contractRetailPrice: 0,
  totalProductRetailValue: 0,
  originalTransactionId: "",
  originalDealerStoreId: "",
  originalContractPurchaseDate: null,
  protectallSku: "",
  documents: [],
  lineItems: [
    {
      id: "",
      manufacturer: "",
      modelNumber: "",
      serialNumber: "",
      purchaseDateOfProduct: null,
      deliveryDateOfProduct: null,
      productRetailPrice: 0,
      quantity: 0,
      productSku: "",
      productDescription: "",
      productQuality: "",
    },
  ],
};

export const pendingContractReducer = (
  state: PendingContractState = initialState,
  action: PendingContractActionTypes
): PendingContractState => {
  switch (action.type) {
    case PendingContractAction.SET_PENDING_CONTRACT_RECORD: {
      return {
        ...state,
        ...(action.payload || {}),
      };
    }

    case PendingContractAction.CLEAN_UP: {
      return {
        ...initialState,
      };
    }

    case PendingContractAction.SET_UPLOADED_DOCUMENTS: {
      return {
        ...state,
        documents: state.documents.concat(action.payload || []),
      };
    }
    default:
      return state;
  }
};
